import React from "react";
import { useLocation } from "react-router";

/**
 * 새 화면 자동 적용 (2026-10-09 사장님): 앱(웹뷰)·브라우저가 처음 받은 화면을 계속 써서, 새로 배포해도 껐다 켜야 바뀌던 문제.
 * 새 배포(index.html 의 main.*.chunk.js 이름이 바뀜)를 알아채 두었다가, 다음에 다른 화면으로 넘어갈 때 조용히 새로 불러온다.
 * 보던 악보·재생 중인 화면은 끊지 않는다 (화면을 옮길 때만 새로고침).
 */
const MAIN_RE = /\/static\/js\/main\.[0-9a-f]+\.chunk\.js/;
const MIN_GAP = 60 * 1000; // 확인은 1분에 한 번까지
const POLL = 10 * 60 * 1000; // 켜 둔 채로 있으면 10분마다

const currentMain = () => {
  const s = Array.from(document.scripts).map((x) => x.src).find((src) => MAIN_RE.test(src));
  const m = s && s.match(MAIN_RE);
  return m ? m[0] : "";
};

const UpdateWatcher: React.FC = () => {
  const { pathname } = useLocation();
  const stale = React.useRef(false);
  const lastCheck = React.useRef(0);
  const first = React.useRef(true);

  const check = React.useCallback(async () => {
    const now = Date.now();
    if (stale.current || now - lastCheck.current < MIN_GAP) return;
    lastCheck.current = now;
    const mine = currentMain();
    if (!mine) return; // 개발 서버 등
    try {
      const html = await (await fetch(`/index.html?_=${now}`, { cache: "no-store" })).text();
      const m = html.match(MAIN_RE);
      if (m && m[0] !== mine) stale.current = true;
    } catch (e) {
      // 네트워크 오류는 다음에 다시
    }
  }, []);

  React.useEffect(() => {
    const onVisible = () => { if (document.visibilityState === "visible") check(); };
    document.addEventListener("visibilitychange", onVisible);
    const t = window.setInterval(check, POLL);
    check();
    return () => { document.removeEventListener("visibilitychange", onVisible); window.clearInterval(t); };
  }, [check]);

  React.useEffect(() => {
    if (first.current) { first.current = false; return; }
    if (stale.current) window.location.reload(); // 이미 새 주소로 옮겨졌으니 그 화면을 새 버전으로 연다
    else check();
  }, [pathname, check]);

  return null;
};

export default UpdateWatcher;
